var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1133 3H29.1922C31.2956 3 33 4.71878 33 6.83994V11.9618C33 14.083 31.2956 15.8017 29.1922 15.8017H24.1133C22.0099 15.8017 20.3055 14.083 20.3055 11.9618V6.83994C20.3055 4.71878 22.0099 3 24.1133 3Z",
    fill: "#EDBAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8867 20.1983C13.9901 20.1983 15.6945 21.917 15.6945 24.0382V29.1601C15.6945 31.2798 13.9901 33 11.8867 33H6.80779C4.70438 33 3 31.2798 3 29.1601V24.0382C3 21.917 4.70438 20.1983 6.80779 20.1983H11.8867ZM29.1922 20.1983C31.2956 20.1983 33 21.917 33 24.0382V29.1601C33 31.2798 31.2956 33 29.1922 33H24.1133C22.0099 33 20.3055 31.2798 20.3055 29.1601V24.0382C20.3055 21.917 22.0099 20.1983 24.1133 20.1983H29.1922ZM11.8867 3C13.9901 3 15.6945 4.71878 15.6945 6.83994V11.9618C15.6945 14.083 13.9901 15.8017 11.8867 15.8017H6.80779C4.70438 15.8017 3 14.083 3 11.9618V6.83994C3 4.71878 4.70438 3 6.80779 3H11.8867Z",
    fill: "url(#paint0_linear_1709_14348)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1709_14348",
    x1: 18,
    y1: 3,
    x2: 18,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#651489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C858EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.d67e5ac36e52cb556780505de566ac73.svg";
export { ForwardRef as ReactComponent };